import LanguageLocalesLocal from '@helsenorge/core-utils/constants/languages';
import type { MimeTypes } from '@helsenorge/file-upload/components/file-upload';

export const SKJEMA_URL = 'skjemautfyller';
export const VEILEDER_URL = 'veileder';
// LOGGETUT_FEILCODES: Fjern EHGW og skriv om til string constant når alle områder er over på Breeze
export const LOGGETUT_FEILCODES = ['EHGW-130004', 'BZGTW-130004'];
export const FEIL = 'FEIL';
export const LANGUAGE_Code = 'lang';
export const DEFAULT_LANGUAGE = LanguageLocalesLocal.NORWEGIAN;
export const TQQC = 'http://ehelse.no/fhir/ValueSet/TQQC';
export const VALID_FILE_TYPES: Array<MimeTypes> = ['image/jpeg', 'image/png', 'application/pdf'];
export const NUMBER_OF_ALLOWED_ATTACHMENTS = 10;
/**
 * - Represents default maximum file size (MegaBytes) allowed for attachments for 'HN Skjema'
 */

export const MAX_ATTACHMENT_FILE_SIZE_HN_SKJEMA_MB = 20;
export const MAX_ATTACHMENT_SINGLE_FILE_FILE_SIZE_HN_SKJEMA_MB = 20;

/**
 * - Represents default maximum file size (bytes) allowed for attachments for 'HN Skjema'
 * - This is the default vaule, note however that Refero can override this setting if
 * - Questionnaires own max validation rule is set.
 */
export const DEFAULT_MAX_ATTACHMENT_FILE_SIZE_HN_SKJEMA_BYTES = MAX_ATTACHMENT_FILE_SIZE_HN_SKJEMA_MB * 1024 * 1024;
export const DEFAULT_MAX_ATTACHMENT_SINGLE_FILE_FILE_SIZE_HN_SKJEMA_BYTES = MAX_ATTACHMENT_SINGLE_FILE_FILE_SIZE_HN_SKJEMA_MB * 1024 * 1024;

export const HN_SKJEMA_FRONTEND_RESOURCES = 'HN.Skjema.Frontend';
export const HN_SKJEMA_ERRORCODES_RESOURCES = 'HN.Skjema.ErrorCodes';
export const REFERO_RESOURCES = 'Refero';
